import React, { Component } from "react";
import VacationProcess from "../../../components/VacationProcess/VacationProcess";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : VacationProcessForm
Description : Compoente que alberga el resto del formulario de registro definido en el directorio de componentes
Date Autor Modification
================================================================================
06/10/2023 Santiago Coca – Se llama al componente de VacationProcess con sus respectivos parámetros.
================================================================================ */

class VacationProcessForm extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <VacationProcess />
        )
    }
}

export default VacationProcessForm;